import { ContentEditTextarea } from '@/common/components/inputs/ContentEditTextarea';
import { Todo } from '@/common/types/databaseTypes';
import { useAuthStore } from '@/stores/authStore';
import { useTodoDrawerStore } from '@/stores/todoDrawerStore';
import { IconNotes } from '@tabler/icons-react';
import { useUpdateTodo } from '../../services/useTodoQueries';

interface TodoDescriptionProps {
    todo: Todo;
    onContentChange?: (content: string) => void;
}

export default function TodoDescription({
    todo,
    onContentChange,
}: TodoDescriptionProps) {
    const { user } = useAuthStore.getState();
    const updateTodoMutation = useUpdateTodo();
    const { isDrawerOpen } = useTodoDrawerStore();

    // Todo 업데이트 함수 정의
    const updateFunction = (id: string, data: Partial<Todo>) => {
        if (!todo?.id) {
            return Promise.resolve(todo);
        }

        return updateTodoMutation.mutateAsync({
            id: todo.id,
            content: data.content,
            update_id: user?.id ?? '',
        });
    };

    return (
        <ContentEditTextarea
            item={todo}
            updateFunction={updateFunction}
            onContentChange={onContentChange}
            autoSave={isDrawerOpen} // drawer가 열려있을 때만 자동 저장
            leftSection={<IconNotes size={16} />}
            leftSectionProps={{
                style: {
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'start',
                    paddingTop: '3px',
                },
            }}
            textareaProps={{
                variant: 'unstyled',
                autosize: true,
                styles: {
                    input: { paddingTop: '0' },
                },
            }}
        />
    );
}
